import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';

const PageConPc = dynamic(() => import('@/components/ProductDelta/deltamininew/indexDynamic'), {
    ssr: true,
});
const webpUrl = '/media/deltamini/pc/';

export default function DeltaMini({ cssStyle }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_mini_new');
    const defaultStyle = {
        background: 'transparent',
        padding: '0',
        margin: '0 auto',
        border: 'none',
        borderRadius: '0',
    };

    const bannerData = [
        {
            bgImgs: ['1_main.webp', '1_main.jpg'],
            title: t('DELTA mini'),
            des: t('banner'),
        },
    ];

    const styles = { ...defaultStyle, ...cssStyle };

    return (
        <div
            className={`${css.deltamini} DeltaMiniModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ position: 'top', titleColor: '#fff', desColor: '#fff', isWebp: true, webpUrl }} theme={'black'} />
            </div>
            <PageConPc />
        </div>
    );
}
